/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {RecaptchaCommonModule as ɵa} from './recaptcha/recaptcha-common.module';